export default "__VITE_ASSET__faab89b5__"